import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";

@Component({
	selector: "obg-m-login-betting-limit-modal",
	templateUrl: "./iaui-login-betting-limit-modal.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class IauiLoginBettingLimitModalComponent {}
